// Desktop device screen for a 4 Scene Controller (DeviceID 101): the four scene
// buttons and each scene's command list. See ui/shared/SceneControllerPanel.

import React from 'react';
import { Card } from '@mui/material';
import DeviceShell from '../../components/DeviceShell';
import { SceneControllerBody } from '../../../shared/SceneControllerPanel';

export default function SceneControllerScreen({ device }) {
  return (
    <DeviceShell title={device.DeviceName || device.UniqueNumber}>
      <Card sx={{ borderRadius: 3, maxWidth: 640 }}>
        <SceneControllerBody device={device} />
      </Card>
    </DeviceShell>
  );
}
